import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { createTheme, getLuminance, ThemeProvider } from "@mui/material/styles";
import i18n from "../src/i18n/config";
import axios from "axios";
import { ToastProvider } from "./contexts/ToastContext";
import { UserProvider } from "./contexts/UserContext";
import { CreatorProvider } from "./contexts/CreatorContext";
import BasePathRouter from "./components/BasePathRouter/BasePathRouter";
import { IframeProvider } from "./contexts/IframeContext";

axios.defaults.headers.common["Accept-Language"] =
	i18n.language === "es" ||
	i18n.language.includes("es-") ||
	i18n.language.includes("-ES") ||
	i18n.language.includes("es_") ||
	i18n.language.includes("_ES") ||
	i18n.language === "ca" ||
	i18n.language === "eu" ||
	i18n.language === "gl"
		? "es"
		: "en";

function App() {
	const [font, setFont] = useState("Montserrat");
	const [mainColor, setMainColor] = useState("#43BD98");

	const theme = createTheme({
		palette: {
			primary: {
				main: mainColor, // Color global principal (puedes cambiar este color)
			},
			secondary: {
				main: "#16a085", // Color secundario
			},
		},
		typography: {
			fontFamily: `'${font}', sans-serif`,
		},
		components: {
			MuiButton: {
				styleOverrides: {
					root: {
						textTransform: "none", // Evitar mayúsculas en los botones
						fontWeight: 600, // Peso de la fuente
						fontSize: "14px", // Tamaño de la fuente
						borderRadius: "8px", // Bordes redondeados
						padding: "8px 24px",
						boxShadow: "none", // Sin sombra predeterminada
						"&:hover": {
							boxShadow: "none", // Eliminar la sombra en hover
						},
					},
					containedPrimary: {
						color: getLuminance(mainColor) >= 0.5 ? "#000000" : "#FFFFFF", // Texto de los botones primarios
						"&:hover": {
							backgroundColor: mainColor, // Color de fondo en hover para primarios (puedes cambiarlo)
							boxShadow: "none", // Sin sombra en hover para botones primarios
						},
					},
					containedSecondary: {
						color: getLuminance(mainColor) >= 0.5 ? "#000000" : "#FFFFFF", // Texto de los botones secundarios
						"&:hover": {
							backgroundColor: mainColor, // Color de fondo en hover para secundarios
							boxShadow: "none", // Sin sombra en hover para botones secundarios
						},
					},
					outlinedPrimary: {
						color: mainColor, // Texto para botones outlined primarios
						borderColor: mainColor, // Borde para botones outlined primarios
						"&:hover": {
							//backgroundColor: "rgba(26, 188, 156, 0.1)", // Fondo semi-transparente en hover
							borderColor: mainColor, // Borde en hover
							boxShadow: "none", // Sin sombra en hover para botones outlined
						},
					},
				},
			},
		},
	});

	return (
		<ThemeProvider theme={theme}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<IframeProvider>
					<CreatorProvider setFont={setFont} setMainColor={setMainColor}>
						<UserProvider>
							<ToastProvider>
								<Router>
									{/* Incluimos la barra de navegación en todas las pantallas */}
									<Routes>
										<Route path="/:basePath/*" element={<BasePathRouter />} />
									</Routes>
								</Router>
							</ToastProvider>
						</UserProvider>
					</CreatorProvider>
				</IframeProvider>
			</LocalizationProvider>
		</ThemeProvider>
	);
}

export default App;
